// src/pages/EstatusFactura.js
import React, { useState } from "react";
import { Button, Container, Typography, Alert } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikTextField from "../components/FormikTextField";
import { useAuth } from "../context/AuthContext";
import { useSftfApi } from "../api/sftfClient";

export default function EstatusFactura() {
  const { auth } = useAuth();
  const { postConsulta } = useSftfApi(auth);
  const [rows, setRows] = useState([]);
  const [error, setError] = useState(null);

  const columns = [
    { field: "id", headerName: "#", width: 70 },
    { field: "serieBitacora", headerName: "Serie Bitácora", width: 120 },
    { field: "folioBitacora", headerName: "Folio Bitácora", width: 140 },
    { field: "serieRemision", headerName: "Serie Remisión", width: 120 },
    { field: "folioRemision", headerName: "Folio Remisión", width: 140 },
    { field: "estatus", headerName: "Estatus", width: 100 },
    { field: "remitenteNombre", headerName: "Remitente", width: 300 },
    { field: "mercanciaDescripcion", headerName: "Descripción", width: 200 },
    { field: "mercanciaPesoKilogramo", headerName: "Peso (kg)", width: 120 },
    { field: "operadorNombre", headerName: "Operador", width: 200 },
  ];

  return (
    <Container>
      <Typography variant="h4" gutterBottom>
        Consulta de Estatus de Factura
      </Typography>

      <Formik
        initialValues={{ Estatus: "" }}
        validationSchema={Yup.object({
          Estatus: Yup.string().required("Requerido"),
        })}
        onSubmit={async (values) => {
          try {
            const query = `claveEstatus=${values.Estatus}`;
            const res = await postConsulta(query);

            const formattedRows = Array.isArray(res)
              ? res.map((item, idx) => ({
                  id: idx + 1,
                  ...item,
                }))
              : [];

            setRows(formattedRows);
            setError(null);
          } catch (err) {
            setError(err.message || "Error desconocido");
            setRows([]);
          }
        }}
      >
        <Form>
          <FormikTextField name="Estatus" label="Estatus" />
          <Button type="submit" variant="contained">
            Consultar
          </Button>
        </Form>
      </Formik>

      {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}

      {rows.length > 0 && (
        <div style={{ height: 500, width: "100%", marginTop: 20 }}>
          <DataGrid
            rows={rows}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[10, 20, 50]}
          />
        </div>
      )}
    </Container>
  );
}
